module.exports = __webpack_public_path__ + "img/testimonials-5.72fb0443.jpg";